<template>
  <div class="supernavbar-wrapper" v-if="cafe">
    <NavbarHost :pages="pages" :topBannerShown="topBannerShown" :selectedPage="selectedRoute"
      @routeClicked="onHostButtonClicked" @userClicked="onHostUserIconClicked" @cafeClicked="onHostCafeButtonClicked"
      @billingClicked="onHostBillingClicked" @marketplaceClicked="onHostMarketplaceClicked" />

    <transition :name="`sidemenu-overlay`">
      <NavbarSidemenu :page="selectedRoute" :topBannerShown="topBannerShown" :variant="sidemenuVariant"
        @linkClicked="onSidemenuLinkClicked" v-if="sidemenuVariant === 'overlay'" />
    </transition>

    <transition :name="`sidemenu-solid`">
      <NavbarSidemenu :page="selectedRoute" :variant="sidemenuVariant" @linkClicked="onSidemenuLinkClicked"
        v-if="sidemenuVariant === 'solid' && !isOnPageWithoutSidemenu" />
    </transition>

    <div class="supernavbar-menu-backdrop" v-if="sidemenuVariant == 'overlay'" @click="onSidemenuBackdropClicked"></div>

    <BaseLanguagePicker :include="['uk', 'en', 'ru']" :uiLocale="$i18n.locale"
      :value="$i18n.locale == 'ua' ? 'uk' : $i18n.locale" @input="changeLocale" @close="isLanguagePickerShown = false"
      v-if="isLanguagePickerShown" />
  </div>
</template>

<script>
import NavbarHost from '@/components/supernavbar/NavbarHost.vue'
import NavbarSidemenu from '@/components/supernavbar/NavbarSidemenu.vue'

import moment from 'moment'

import AuthAPI from '@/api/auth'

export default {
  components: {
    NavbarHost,
    NavbarSidemenu
  },
  props: {
    topBannerShown: Boolean
  },
  data () {
    return {
      selectedRoute: null,

      isLanguagePickerShown: false
    }
  },
  watch: {
    isNavbarCollapsed () {
      if (this.isNavbarCollapsed) {
        this.selectedRoute = null
      }
    },
    cafeModes: {
      deep: true,
      handler () {
        //we need to reset selected route with updated system badges when they are toggled on/off
        if (this.selectedRoute && this.selectedRoute.name == 'systems') {
          this.selectedRoute = this.pages.find(p => p.name == 'systems')
        }
      }
    },
    pages () {
      this.$nextTick(this.updateActiveRoute)
    }
  },
  methods: {
    executeLogout () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    },
    changeLocale (_locale) {
      // let index = this.availableLocales.findIndex(
      //   (l) => l == this.$i18n.locale
      // );

      // let locale_to_set = "ua";

      // if (index !== -1) {
      //   index++;
      //   if (index >= this.availableLocales.length) index = 0;

      //   locale_to_set = this.availableLocales[index];
      // }

      // this.$i18n.locale = locale_to_set;
      // if (locale_to_set == "ua") {
      //   moment.locale("uk");
      // } else {
      //   moment.locale(locale_to_set);
      // }
      let locale = _locale

      moment.locale(locale)

      this.$i18n.locale = locale

      window.localStorage.setItem('locale', locale)

      AuthAPI.setDashboardLanguage(locale)

      //re-render
      this.onHostUserIconClicked()
    },
    onHostButtonClicked (route) {
      this.selectedRoute = route

      //always open first child on click
      if (route.children) {
        const first_clickable_child = route.children.find(c => c.name || c.path)
        if (first_clickable_child) this.onSidemenuLinkClicked(first_clickable_child)
      }
    },
    onSidemenuBackdropClicked () {
      this.selectedRoute = null
    },
    onSidemenuLinkClicked (route) {
      if (route.name == 'logout') {
        this.executeLogout()
        return
      }

      if (route.name == 'language') {
        this.isLanguagePickerShown = true
        return
      }

      if (route.path) {
        this.$router.push({ path: route.path })
      } else {
        this.$router.push({ name: route.name })
      }
    },
    onHostCafeButtonClicked () {
      this.selectedRoute = {
        name: 'workspace',
        special: 'workspace'
      }
    },
    onHostMarketplaceClicked () {
      this.$router.push('/integrations')
      this.selectedRoute = null
    },
    onHostBillingClicked () {
      this.$router.push('/superbilling')
      this.selectedRoute = null
    },
    checkUserPermission (perm) {
      return this.$store.getters['checkUserPemission'](perm)
    },
    onHostUserIconClicked () {
      const userFlagPath = {
        en: 'https://cdn.qrwaiter.com.ua/assets/flags/v2-wavy/united-kingdom.png',
        ru: 'https://cdn.qrwaiter.com.ua/assets/flags/v2-wavy/russia.png',
        uk: 'https://cdn.qrwaiter.com.ua/assets/flags/v2-wavy/ukraine.png',
        ua: 'https://cdn.qrwaiter.com.ua/assets/flags/v2-wavy/ukraine.png'
      }[this.$i18n.locale]

      this.selectedRoute = {
        name: 'profile',
        icon: 'user',
        children: [
          {
            name: 'settings',
            fullHeight: true
          },
          {
            name: 'notifications'
          },
          {
            divider: true
          },
          {
            name: 'language',
            imageIcon: userFlagPath,
            rightIcon: 'chevron-right'
          },
          {
            divider: true
          },
          {
            name: 'logout',
            rightIcon: 'log-out',
            color: 'content-error-primary'
          }
        ]
      }
    },
    updateActiveRoute () {
      const activePage = this.pages.find(pg =>
        pg.children.find(ch => ch.name == this.$route.name || ch.path === this.$route.path)
      )

      this.selectedRoute = activePage || this.pages[0]

      console.log(`active:`, activePage)
    }
  },
  mounted () {
    const is_collapsed = window.localStorage.getItem('navbar_collapsed')

    if (is_collapsed) {
      this.$store.commit('ui/setNavbarCollapsed', true)
    } else {
      this.$nextTick(this.updateActiveRoute)
    }
  },
  computed: {
    availableLocales: () => ['ua', 'ru', 'en'],
    cafe () {
      return this.$store.state.cafe
    },
    isOnPageWithoutSidemenu () {
      if (this.selectedRoute && this.selectedRoute.name === 'profile') return false;
      return ['superbilling', 'integrations'].includes(this.$route.name)
    },
    cafeModes () {
      if (!this.cafe) return []
      return this.$store.state.cafe.modes
    },
    isNavbarCollapsed () {
      return this.$store.state.ui.navbar_collapsed
    },
    sidemenuVariant () {
      if (this.selectedRoute && this.selectedRoute.hideSidemenu) return null

      if (this.isNavbarCollapsed) {
        return this.selectedRoute ? 'overlay' : null
      } else {
        return 'solid'
      }
    },
    isHotel () {
      return this.cafe.primary_category == 'hotel'
    },
    pages () {
      //This computed property builds the tree-like structure of the navbar dynamically

      const systemsPage = {
        name: 'systems',
        icon: 'grid',
        children: []
      }

      const integrationsPageChildren = [];

      const base = [
        {
          name: 'stats',
          icon: 'bar-chart-02',
          route: 'stats_orders',
          hideSidemenu: true,
          children: [{ name: 'stats_orders' }]
        },
        {
          name: 'marketing',
          icon: 'activity-heart',
          children: [{ name: 'clients_base' }, { name: 'reviews' }, { name: 'tools' }]
        },
        {
          name: 'settings',
          icon: 'settings-02',
          children: [{ name: 'general' }, { name: 'taxes' }, { name: 'halls' }, { name: 'working_schedule' }]
        },
        {
          name: 'menu',
          icon: 'book-open',
          children: [{ name: 'menus' }, { name: 'nomenculature_packaging' }]
        },
        {
          name: 'team',
          icon: 'users',
          children: [{ name: 'workers' }, { name: 'corporate_users' }]
        },
        {
          name: 'tips_settings',
          icon: 'coins-hand',
          route: 'tips_settings',
          hideSidemenu: true,
          children: [{ name: 'tips_settings' }]
        },
        {
          name: 'interfaces',
          icon: 'phone',
          children: [
            // { section_title: this.$t('navbar_pages.menu') },
            {
              name: 'client_app',
              title: this.$t('navbar_pages.menu')
              // leftIcon: 'phone'
            },
            // { section_title: this.$t('navbar_pages.orders_panel') },
            {
              name: 'orders_panel',
              title: this.$t('navbar_pages.orders_panel')
              // leftIcon: 'phone'
            }
          ]
        },
        systemsPage,
        {
          icon: 'marketplace', name: 'integrations',
          children: integrationsPageChildren

        },
        {
          name: 'sms',
          icon: 'message-circle',
          children: [
            {
              name: 'balance',
              title: this.$t('navbar.billing')
            },
            {
              name: 'sms_settings',
              title: this.$t('navbar.cafe_settings') //lazy to add another translation
            }
          ]
        },
        {
          name: 'forms',
          icon: 'file',
          children: [
            {
              name: 'checklists',
              title: this.$t('checklists.tab_forms')
            },
            {
              name: 'checklists_reports',
              title: this.$t('checklists.tab_reports')
            }
          ]
        }
      ]

      //Systems - we are modifying the already included systemsPage object
      let availableSystems = []
      let otherSystems = []

      let systemNames = ['preview', 'inside', 'preorder', 'delivery']

      if (this.cafe.reserve && this.cafe.reserve.use_superapp) {
        systemNames.push('reserve')
      }

      //demo id
      if (this.cafe._id === 622) {
        systemNames = ['preview', 'inside'];
      }

      const systemIcons = {
        inside: 'utensils',
        preorder: 'packet',
        reserve: 'do-not-disturb',
        delivery: 'scooter',
        preview: 'image'
      }

      if (this.isHotel) systemNames.push('hotels')

      if (this.cafe && this.cafeModes)
        for (const systemName of systemNames) {
          //TODO: fix it
          const billingSystemName = systemName == 'preorder' ? 'takeaway' : systemName

          const systemIsIncludedInPricingPlan = this.$store.getters['checkBillingPlanForPaidService'](billingSystemName)

          const systemItem = {
            name: systemName == 'reserve' && this.cafe.reserve.use_superapp ? 'reserve_new' : systemName,
            leftIcon: systemIcons[systemName],
            systemBadge: this.cafeModes[systemName] && systemIsIncludedInPricingPlan ? 'on' : 'off',
            betaBadge: systemName == 'reserve'
          }

          if (systemIsIncludedInPricingPlan) {
            availableSystems.push(systemItem)
          } else {
            otherSystems.push(systemItem)
          }
        }

      if (availableSystems.length) {
        //if we have inside, hide the preview
        if (availableSystems.find(s => s.name == 'inside')) {
          availableSystems = availableSystems.filter(s => s.name != 'preview')
        }

        systemsPage.children.push({
          divider: true,
          dividerText: this.$t('navbar.systems_in_your_plan')
        })
        systemsPage.children.push(...availableSystems)

      }

      if (otherSystems.length) {
        systemsPage.children.push({
          divider: true,
          dividerText: this.$t('navbar.systems_extra')
        })
        systemsPage.children.push(...otherSystems)
      }

      if (systemsPage.children.length == 1) {
        systemsPage.hideSidemenu = true
      }

      //Integrations
      if (this.checkUserPermission('integrations')) {
        const allIntegrations = this.$store.state.integrations.catalogue;

        const categories = {};

        for (const integration of allIntegrations) {
          if (!integration.platform_options || !integration.platform_options.add_to_navbar) continue;

          const isConnected = this.$store.getters['integrations/isConnected'](integration._id);

          if (!categories[integration.category]) {
            categories[integration.category] = [];
          }

          categories[integration.category].push({
            path: integration.platform_options.navbar_route,
            title: integration.platform_options.navbar_title,
            imageIcon: integration.platform_options.navbar_icon,
            systemBadge: isConnected ? 'on' : 'off'
          });
        }

        for (const [key, list] of Object.entries(categories)) {
          integrationsPageChildren.push({
            divider: true,
            dividerText: this.$t(`integrations_market.categories.${key}`)
          });

          integrationsPageChildren.push(...list);
        }
      }

      // Last one is superbilling
      base.push({
        icon: 'currency-dollar-circle-filled',
        route: 'superbilling',
        activeIcon: 'currency-dollar-circle',
        name: 'superbilling',
        hideSidemenu: true,
        children: [
          {
            name: 'superbilling'
          }
        ]
      });

      return base
    }
  }
}
</script>

<style scoped>
.supernavbar-wrapper {
  display: flex;
  flex-direction: row;
  transition: 1s;
  background: var(--qrw-background-base-inverse-primary);
}

.supernavbar-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 15;
}

.sidemenu-overlay-enter-active {
  animation: slide-in 0.5s;
}

.sidemenu-overlay-leave-active {
  animation: slide-in 0.5s reverse;
}

.sidemenu-solid-enter-active {
  animation: slide-in-solid 0.3s;
}

.sidemenu-solid-leave-active {
  animation: slide-in-solid 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0%);
  }
}

@keyframes slide-in-away {
  0% {
    transform: translateX(0);
    opacity: 1;
  }

  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
}

@keyframes slide-in-solid {
  0% {
    margin-left: -256px;
  }

  100% {
    margin-left: 0;
  }
}
</style>
